// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__pCvSn","root":"styles_root__OmB2l","description":"styles_description__4+-Sw","note":"styles_note__HYsF1","actions":"styles_actions__bT83u"};